module.exports = __webpack_public_path__ + "img/scroll.e651fe57.svg";